import {Card, Subtitle} from "@reside/ui";

import {Space} from "../../../../../atoms/space";
import {DownloadButton} from "./DownloadButton";
import {DownloadArbitrationPDFButton} from "./DownloadArbitrationPDFButton";

type DownloadTemplateFormProps = {
  facilityTemplate: string;
};

export const DownloadTemplateForm = ({
  facilityTemplate,
}: DownloadTemplateFormProps) => (
  <Card>
    <Subtitle>Files</Subtitle>
    <Space style={{marginTop: "16px"}}>
      <DownloadButton
        facilityTemplate={facilityTemplate}
        label="Download Empty Packet"
      />

      <DownloadArbitrationPDFButton
        facilityTemplate={facilityTemplate}
        type="empty"
      />
    </Space>
  </Card>
);
